module.exports = __webpack_public_path__ + "static/media/stress.ab6aef6c.svg";